import { render } from "./ListeAdressePostale.vue?vue&type=template&id=640bef6c&ts=true"
import script from "./ListeAdressePostale.vue?vue&type=script&lang=ts"
export * from "./ListeAdressePostale.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__